import React, { useState } from "react";
import Button from "@components/buttons/Button/Button";
import Card from "@components/cards/Card/Card";
import ConfirmationPopup from "@components/modals/ConfirmationPopup/ConfirmationPopup";
import { sendPrivacyPolicyUpdateNotification, sendTermsUpdateNotification } from "@services/notificationService";
import commonStyles from "@styles/CommonPageLayout.module.css";
import styles from "./NotificationsPage.module.css";

const NotificationsPage: React.FC = () => {
    const [showTermsPopup, setShowTermsPopup] = useState(false);
    const [showPrivacyPopup, setShowPrivacyPopup] = useState(false);

    const handleSendTermsUpdateEmail = async () => {
        try {
            await sendTermsUpdateNotification();
            alert("Terms update email sent to all users successfully.");
            setShowTermsPopup(false);
        } catch (error) {
            alert("Failed to send terms update email. Please try again.");
        }
    };

    const handleSendPrivacyPolicyUpdateEmail = async () => {
        try {
            await sendPrivacyPolicyUpdateNotification();
            alert("Privacy Policy update email sent to all users successfully.");
            setShowPrivacyPopup(false);
        } catch (error) {
            alert("Failed to send privacy policy update email. Please try again.");
        }
    };

    return (
        <div className={commonStyles.container}>
            <h1>Notifications</h1>
            <Card className={styles.container}>
                <Button
                    variant="secondary"
                    size="medium"
                    onClick={() => setShowTermsPopup(true)}
                >
                    Send T&C Update
                </Button>
                <Button
                    variant="secondary"
                    size="medium"
                    onClick={() => setShowPrivacyPopup(true)}
                >
                    Send Privacy Policy Update
                </Button>
            </Card>
            <ConfirmationPopup
                visible={showTermsPopup}
                onConfirm={handleSendTermsUpdateEmail}
                onCancel={() => setShowTermsPopup(false)}
                message="Are you sure you want to send the terms update email to all users?"
                confirmButtonText="Yes, Send Email"
                variant="primary"
            />
            <ConfirmationPopup
                visible={showPrivacyPopup}
                onConfirm={handleSendPrivacyPolicyUpdateEmail}
                onCancel={() => setShowPrivacyPopup(false)}
                message="Are you sure you want to send the privacy policy update email to all users?"
                confirmButtonText="Yes, Send Email"
                variant="primary"
            />
        </div>
    );
};

export default NotificationsPage;
